import type { NotificationItem } from '@/types/notification';

type Data = NotificationItem['data'];

/** Title in the dashboard's language: core's own `title_ar` in Arabic when it
 *  sent one (UF-14), the payload's title otherwise. */
export const notificationTitle = (data: Data, lang: string): string | undefined =>
  lang.startsWith('ar') && data?.title_ar?.trim() ? data.title_ar : data?.title;

/** A bilingual payload (one with `title_ar`) describes itself as
 *  "English line\nArabic line"; showing it whole printed both languages, so
 *  each language takes its own line. Older payloads are returned as they are. */
export const notificationDescription = (data: Data, lang: string): string | undefined => {
  const raw = data?.description;
  if (!raw || !data?.title_ar?.trim()) return raw;
  const cut = raw.indexOf('\n');
  if (cut < 0) return raw;
  return (lang.startsWith('ar') ? raw.slice(cut + 1) : raw.slice(0, cut)).trim();
};
